import { useState } from "react";
import CarMakes from "./carMakes";
import CarStyles from "./carStyles";
import { register } from "swiper/element/bundle";
import RangeFilter from "./rangeFilters";
import { FilterForSmallerScreensProps } from "../types";
import ViewCars from "./viewCars";
import FilterHeader from "./filtersHeader-sm";
import { useAppSelector } from "../../../../../../redux/hooks";
import styles from "../ourCars.module.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/a11y";
import "swiper/css/pagination";
import { A11y } from "swiper/modules";
register();

const FiltersForSmallerScreens = ({
  makeList,
  styleList,
  rangeSliderList,
  onRangeFilterChange,
  onClearAll,
}: FilterForSmallerScreensProps) => {
  const [showFilters, setShowFilters] = useState(false);
  const filterHeaderHeight = useAppSelector(state => state.cars.filterHeaderHeight);
  const viewCarsDivHeight = useAppSelector(state => state.cars.viewCarsDivHeight);
  const selectedFilter = useAppSelector(state => state.cars.filter);
  const onClearingFilters = () => {
    onClearAll();
    setShowFilters(false);
  };

  return (
    <>
      <div className={`flex bg-white rounded cursor-pointer`} onClick={() => setShowFilters(true)}>
        <button className={selectedFilter === null ? "" : "bg-[#ff8200]"}>
          <svg
            className={`w-10 h-10 p-2 ${selectedFilter === null ? styles.filterBtnForSmallScreens : styles.filterBtnForSmallerScreenWhenFilterSelected}`}>
            <use xlinkHref="/assets/svgs/icons.svg#icon-settings"></use>
          </svg>
        </button>
      </div>
      {showFilters && (
        <div
          className="fixed top-0 left-0 z-[1001] bg-white w-full h-full px-2"
          data-testid="filterHeaderForSmallDevices">
          <FilterHeader onClearAll={onClearingFilters} onRangeFilterChange={onRangeFilterChange} />
          <hr className="my-4" />
          <Swiper
            modules={[A11y]}
            slidesPerView={1}
            pagination={{ clickable: true }}
            style={{
              height: `calc(100% - ${filterHeaderHeight + viewCarsDivHeight + 33}px)`,
            }}>
            <SwiperSlide>
              <CarMakes makeList={makeList} isSmView={true} viewCarsDivHeight={viewCarsDivHeight} />
            </SwiperSlide>
            <SwiperSlide>
              <CarStyles styleList={styleList} isSmView={true} viewCarsDivHeight={viewCarsDivHeight} />
            </SwiperSlide>
            <SwiperSlide className="px-8">
              <h3 className="font-medium filterSubHeaders">Other</h3>
              {rangeSliderList.map((rangeSliderProps, index) => (
                <div key={index} className="my-10">
                  <RangeFilter
                    label={rangeSliderProps.label}
                    initialValue={rangeSliderProps.initialValue}
                    onRangeFilterChange={onRangeFilterChange}
                    path={rangeSliderProps.path}
                    className="w-full px-6"
                    isSmView={true}
                  />
                </div>
              ))}
            </SwiperSlide>
          </Swiper>
          <ViewCars onViewCarsCallback={setShowFilters} />
        </div>
      )}
    </>
  );
};

export default FiltersForSmallerScreens;
